<template>
  <router-view/>
</template>

<style lang="scss">
/* 基础样式与变量 */
// :root {
//   --primary-color: #dc2626; /* 主红色 */
//   --primary-dark: #991b1b; /* 深红色 */
//   --primary-light: #fee2e2; /* 浅红色 */
//   --secondary-color: #1e293b;
//   --light-color: #f8fafc;
//   --gray-light: #f1f5f9;
//   --gray: #94a3b8;
//   --gray-dark: #334155;
//   --dark-color: #0f172a;
//   --success-color: #10b981;
//   --transition: all 0.3s ease;
// }
// :root {
//   --primary-color: #d97706; /* 主金黄色（温暖明亮的金色） */
//   --primary-dark: #b45309; /* 深金黄色（hover状态） */
//   --primary-light: #fef3c7; /* 浅金黄色（背景辅助色） */
//   --secondary-color: #1e293b;
//   --light-color: #f8fafc;
//   --gray-light: #f1f5f9;
//   --gray: #94a3b8;
//   --gray-dark: #334155;
//   --dark-color: #0f172a;
//   --success-color: #10b981;
//   --transition: all 0.3s ease;
// }
:root {
  /* 主色调：呼应logo红色背景，选用沉稳的暗红色作为基础 */
  --primary-color: #c22525; /* 深红主色（比logo背景略暗，避免刺眼） */
  --primary-dark: #9a1c1c; /* 更深的红色（hover状态，增强层次感） */
  --primary-light: #fdebeb; /* 浅红色（辅助背景，呼应主色） */
  
  /* 强调色：呼应logo金色，用于重点元素 */
  --accent-color: #e6b325; /* 暖金色（与logo金色协调） */
  --accent-dark: #c99d15; /* 深金色（hover状态） */
  --accent-light: #fff4d2; /* 浅金色（辅助背景） */
  
  /* 中性色：保证内容可读性 */
  --secondary-color: #1e293b; /* 深灰文本 */
  --light-color: #ffffff; /* 白色背景 */
  --gray-light: #f1f5f9; /* 浅灰背景 */
  --gray: #94a3b8; /* 中灰文本 */
  --gray-dark: #334155; /* 深灰文本 */
  --dark-color: #0f172a; /* 近黑背景 */
  
  /* 功能色与过渡 */
  --success-color: #166534; /* 成功色（偏暗绿，与红金协调） */
  --transition: all 0.3s ease;
}


* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* {
  margin: 0;
  padding: 0;
  // width: 100%;
  // height: 100%;
  box-sizing: border-box;
  font-family: Calibri,楷体,华文楷体;
  // font-size:20px;
}
ul li {
  list-style-type: none;
}
.el-button {
  font-family: Calibri,楷体,华文楷体 !important;
  // font-size: 20px !important;
}


</style>
